import { Box, Button, Typography, makeStyles } from '@material-ui/core';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useDataProvider } from "react-admin";
import { useTranslate } from 'react-admin';
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import CustomTable from '../common/table/CustomTable';
import { headExternalDeviceCells } from '../utils';
import { Loading } from 'react-admin';
import { ExternalDevice, ExternalDeviceListProps } from '../types';
import EditAndCreateExternalDevice from './EditAndCreateExternalDevice';
import Plus from '../assets/icons/white-plus.png'

const useStyles = makeStyles(theme => ({
    TitleUser: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    borderCreate: {
        borderRadius: '10px',
    },
    textbtnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    input: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        cursor: 'pointer !important',
        opacity: 0,
    },
    subText: {
        fontFamily: 'UniviaPro-Medium',
        fontWeight: 500,
        lineHeight: "13.2px",
        marginLeft: 10,
        letterSpacing: 'normal',
        color: '#88898c',
        fontSize: 11
    },
    Title: {
        fontFamily: "UniviaPro-Bold",
        fontSize: '13px',
        letterSpacing: '0.13px ',
        lineHeight: '16.3px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        color: '#4f5064'
    },
    Close: {
        fontFamily: "UniviaPro",
        fontSize: '10px',
        letterSpacing: '0.4px ',
        lineHeight: '12.5px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
    },
    textTab: {
        fontSize: 13,
        color: '#4f5064',
        fontFamily: 'UniviaPro',
        fontWeight: 'normal',
        letterSpacing: '0.13px',
        lineHeight: '16.3px',
        fontStyle: 'normal',
        fontStretch: 'normal',
        padding: '5px'
    }
}));

const ExternalDeviceList = ({ roomID, roomData }: ExternalDeviceListProps) => {
    const dataProvider = useDataProvider();
    const classes = useStyles();
    const translate = useTranslate();

    const [loading, setLoading] = useState(false);
    const [externalDevices, setExternalDevices] = useState<Array<ExternalDevice>>([]);
    const [total, setTotal] = React.useState(0);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [sort, setSort] = useState({
        field: 'name',
        order: 'ASC'
    });
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 10
    });
    const [stateExternalDevice, setStateExternalDevice] = useState(0);
    const [itemRow, setItemRow] = useState<Partial<ExternalDevice>>({});

    const getListExternalDevice = () => {
        setLoading(true)
        try {
            dataProvider('GET_LIST', "external-device", {
                filter: {},
                pagination: {
                    page: 1,
                    perPage: -1
                },
                sort: { field: 'createdAt', order: 'ASC' },
            }).then(({ data }: any) => {
                setExternalDevices(
                    data.filter((d: any) =>
                        roomData['devices']
                            ?.some((r: any) => r.id
                                ?.includes(d?.macAddressBox))) || []
                );
                setTotal(data.length || 0);
                setLoading(false);
            }).catch((error: any) => {
                // TODO: Should show error message
                console.error('get External Device error:', error)
            });
        } catch (error) {
            console.log('get External Device err', error)
        }
    }

    const onGetList = (sortObj: { field: string; order: string }, paginationObj: { page: number; perPage: number; }) => {
        setSort(sortObj)
        setPagination(paginationObj)
    }

    const handleCheckMark = (event: ChangeEvent<HTMLInputElement>, index: number, checkAll?: boolean | undefined) => {
        let temps: Array<ExternalDevice> = externalDevices.slice()
        if (!checkAll)
            temps[index].checked = event.target.checked
        else
            temps.map((item: any) => {
                item.checked = event.target.checked
                return item
            })
        setExternalDevices(temps)
    }


    useEffect(() => {
        getListExternalDevice()
    }, [sort, pagination])

    const handleDelete = () => {
        var requests: any[] = []
        externalDevices.forEach((element: any) => {
            element.checked && requests.push(
                dataProvider('DELETE', "externalDevice", {
                    id: element.id
                })
            )
        })
        if (requests.length > 0) {
            Promise.all(requests).then(() => {
                getListExternalDevice()
                setOpenConfirmDialog(false)
            }).catch(error => {
                setOpenConfirmDialog(false)
            });
        }
        else
            setOpenConfirmDialog(false)

    }

    const onClear = () => {
        let temps = externalDevices.slice()
        temps.map((item: any) => {
            delete item.checked
            return item
        })
        setExternalDevices(temps)
    }

    const onGoBack = () => {
        setStateExternalDevice(0)
        getListExternalDevice()
    }

    useEffect(() => {
        getListExternalDevice()
    }, []);

    if (loading) return <Loading />;

    switch (stateExternalDevice) {
        case 1:
            return <EditAndCreateExternalDevice
                itemRow={itemRow}
                onGoBack={onGoBack}
                roomID={roomID}
            />
        case 2:
            return <EditAndCreateExternalDevice
                roomID={roomID}
                onGoBack={onGoBack}
            />
        default:
            return (
                <Box width="100%" display='flex' justifyContent='center' pt={2}>
                    <Box width="90%">
                        <Box display="flex" py={3}>
                            <Box flexGrow={1} display="flex" flexDirection="row" alignItems="center" >
                                <Typography className={classes.TitleUser} color="textPrimary">{translate(`pos.externalDevice.list`)}</Typography>
                                {
                                    total > 0 ? <Typography className={classes.subText}>({total})</Typography>
                                        : <Typography className={classes.subText}>(0)</Typography>
                                }
                            </Box>
                            <Button
                                variant="contained"
                                color='primary'
                                className={classes.borderCreate}
                                endIcon={<img src={Plus} height={18} style={{ width: "18px" }} />}
                                onClick={() => setStateExternalDevice(2)}
                            >
                                <Typography className={classes.textbtnCreate}>{translate(`pos.externalDevice.add`)}</Typography>
                            </Button>
                        </Box>
                        <Box mt={1}>
                            <CustomTable
                                checked={externalDevices.length > 0 && externalDevices.filter((item: any) => item.checked)}
                                handleCheckMark={handleCheckMark}
                                data={externalDevices}
                                total={total}
                                getList={onGetList}
                                onClear={onClear}
                                onDelete={() => {
                                    setOpenConfirmDialog(true)
                                }}
                                error={externalDevices.length}
                                headerCell={headExternalDeviceCells}
                                setStateExternalDevice={setStateExternalDevice}
                                setItemRow={setItemRow}
                            />
                        </Box>
                        <ConfirmDialog
                            open={openConfirmDialog}
                            handleClose={() => { setOpenConfirmDialog(false) }}
                            handleConfirm={handleDelete}
                            ContentText={translate(`pos.externalDevice.confirmDelete`)}
                            Tittle={translate(`pos.externalDevice.titleConfirm`)} />
                    </Box>
                </Box>
            );
            break;
    }
}

export default ExternalDeviceList;
